export const RoleNames = ['MASTER', 'MANAGER'];
